
<!-- Elev Plus Hero Section -->

<div class="elev-hero">


  <div class="hero-content">


  <div class="hero-right">

    <h1>11plus Focused Classes <br>
    & Exam Preparation </h1>
    <h3>GL | CSSE | FSCE | SET</h3>
    <h3>ONLINE 1-2-1 & GROUP CLASSES</h3>
    <button routerLink="/freedemo">Enroll Now</button>

  </div>


  <div class="hero-left">

    <div class="hero-ft">

    <div class="hero-card">
      
      <img src="assets/images/hft-1.jpg" alt="online tutor">

      <div>
        <h4>Online Tutoring</h4>
        <button routerLink="/product-services"> Learn More</button>
      </div>
    </div>

    <div class="hero-card">
      
      <img  src="assets/images/hft-2.jpg" alt="online tutor">

      <div>
        <h4>Mock Exams</h4>
        <button routerLink="/11plus-mock-test"> Learn More</button>
      </div>

    </div>

    <div class="hero-card">
      
      <img src="assets/images/hft-3.jpg" alt="online tutor">

      <div>
        <h4>Crash Couses</h4>
        <button routerLink="/product-services"> Learn More</button>
      </div>
    </div>

    <div class="hero-card">
      
      <img src="assets/images/elv-sprint.jpg" alt="online tutor">

      <div>
        <h4>11+ Sprint Success</h4>
        <button routerLink="/11plus-sprint"> Learn More</button>
      </div>
    </div>


  </div>


  </div>

  </div>

</div>

<!-- Elev Plus Hero Section ends here -->


<!-- Testimonial Section Start Here -->

<div class="testmonials">

  <h1>What Parents Say About Us?</h1>

  <!-- Testimonial Section -->

<div class="sec-4">
   
   
     <div class="cs-sec">
   
   
       <iframe src="https://www.youtube.com/embed/Q9O1heDQfHI?si=L6dN-k9-bHMIJhma" title="Happy Parents Speak: Success Stories &amp; Testimonials 02" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
   
       <iframe src="https://www.youtube.com/embed/fVU0xDgiclA" title="Happy Parents Speak: Success Stories &amp; Testimonials 02" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

       <iframe src="https://www.youtube.com/embed/fVU0xDgiclA" title="Happy Parents Speak: Success Stories &amp; Testimonials 02" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
   
     </div>

     <div class="spacer"></div>
     

   </div>


 <!-- Testimonial Ends -->


 <button class="cta-1">View All</button>


</div>


<!-- Testimonial Section End Here -->


<!-- Strip 1 -->

<div class="strip">


  <h1>10K+ Successful Students placed at top 
<br>Grammar Schools in UK </h1>

<button class="cta-1" routerLink="/freedemo">Enroll Now</button>

</div>


<!-- Strip 1 ends here -->




<!-- Strategy Section Starts here -->

<div class="strategy">

  <h1>SEHYOG Strategy</h1>

  <h3>Comprehensive Offerings Under One Umbrella</h3>


  <!-- Slider -->

  <section class="slider" aria-label="Feature highlights">

  <button class="nav prev" (click)="prev()" aria-label="Previous slide"></button>
  <button class="nav next" (click)="next()" aria-label="Next slide"></button>

  <div #viewport
       class="viewport"
       tabindex="0"
       role="group"
       aria-roledescription="carousel"
       (keydown)="onKeydown($event)"
       (pointerdown)="dragStart($event)"
     (pointermove)="dragMove($event)"
     (pointerup)="dragEnd($event)"
     (pointerleave)="dragEnd($event)">>

    <article *ngFor="let c of cards; let i = index"
             #cardEl
             class="card snap"
             (click)="toggleOverlay(i)"
             (mouseleave)="hideOverlay()"
             [attr.aria-label]="(i+1) + ' of ' + cards.length"
             [attr.aria-hidden]="i!==currentIndex">

      <header class="text">
        <h3 class="title">{{ c.title }}</h3>
        <p class="subtitle" [innerHTML]="c.subtitle"></p>
        <span class="hover-chip" *ngIf="c.hover">{{ c.hover }}</span>
      </header>

      <figure class="thumb">
        <img [src]="c.img" [alt]="c.imgAlt" loading="lazy">
      </figure>

      <div class="overlay" [class.show]="showOverlayIndex === i" *ngIf="c.desc">
        <p class="desc" [innerHTML]="c.desc"></p>
      </div>
    </article>
  </div>

  <div class="dots" role="tablist" aria-label="Slide navigation">
    <button *ngFor="let _ of cards; let i = index"
            role="tab"
            [attr.aria-selected]="i===currentIndex"
            [class.active]="i===currentIndex"
            (click)="goTo(i)"
            [attr.aria-label]="'Go to slide ' + (i+1)">
    </button>
  </div>
</section>





</div>


<!-- Strategy Section Ends Here -->


<!-- Course and Subjects  -->

<div class="spacer"></div>

<div class="subjects">

<h1>Courses & Subjects We Offer</h1>


  <ul class="subject-list u">
    <li>Mathematics</li>
    <li>Enlish Grammar</li>
    <li>Creative Writing</li>
    <li>Reading Comprehension</li>
  </ul>

  <ul class="subject-list">
   <li>Verbal Reasoning</li>
    <li>Non-Verbal Reasoning</li>
    <li>Spatial Reasoning</li>
    <li>Quantitative Reasoning</li>
  </ul>

  <div class="spacer"></div>
  <!-- Courses -->

  <div class="course-container">
        <!-- Fast Forward Course Card -->
        <div class="course-card">
            <div class="card-header orange-gradient">
                <div class="card-title">
                    Fast Forward Course <span class="title-icon">▶▶</span>
                </div>
                <div class="card-subtitle">
                    Fast forward Course for Year 5, Year 4 and Year 3 Students
                </div>
            </div>
            
            <div class="card-content">
                <div class="info-section">
                    <div class="section-label">RECOMMENDED FOR:</div>
                    <div class="section-text">Year 5, 4 & 3 students</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">DURATION:</div>
                    <div class="section-text">35-45 Weeks</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">SESSIONS:</div>
                    <div class="section-text">105 - 315 Sessions</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">PROVIDED:</div>
                    <ul class="feature-list">
                        <li>Course Structure & Pre-Lecture Material (PLM),</li>
                        <li>Daily / Weekly Home / Class</li>
                        <li>Face to Face Unit, Topic Tests,</li>
                        <li>Fortnightly Revision Tests,</li>
                        <li>Weekly Doubt Clearing Sessions</li>
                    </ul>
                </div>
                
                <div class="info-section">
                    <div class="section-label">FEE SCHEDULE:</div>
                    <div class="section-text">Advance One Time Payment / Monthly Payment</div>
                </div>
                
                <button class="demo-btn" routerLink="/freedemo">Book a Free Demo</button>
            </div>
        </div>
        
        <!-- Regular Course Card -->
        <div class="course-card">
            <div class="card-header orange-gradient">
                <div class="card-title">
                    Regular Course <span style="font-size: 14px; font-weight: normal;">(Pay As You Go)</span>
                </div>
                <div class="card-subtitle">
                    Basics to Best Level 11+ Preparation for Year 3, 4 & 5 Students
                </div>
            </div>
            
            <div class="card-content">
                <div class="info-section">
                    <div class="section-label">RECOMMENDED FOR:</div>
                    <div class="section-text">Year 5, 4 & 3 students</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">DURATION:</div>
                    <div class="section-text">Flexible</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">SESSIONS:</div>
                    <div class="section-text">Flexible</div>
                </div>
                
                <div class="info-section">
                    <div class="section-label">PROVIDED:</div>
                    <ul class="feature-list">
                        <li>Course Structure & Pre-Lecture Material (PLM),</li>
                        <li>Daily / Weekly Home / Class</li>
                        <li>Face to Face Unit, Topic Tests,</li>
                        <li>Revision Tests,</li>
                        <li>Doubt Clearing Sessions</li>
                    </ul>
                </div>
                
                <div class="info-section">
                    <div class="section-label">FEE SCHEDULE:</div>
                    <div class="section-text">Monthly Payment</div>
                </div>
                
                <button class="demo-btn" routerLink="/freedemo">Book a Free Demo</button>
            </div>
        </div>



</div>

<div class="spacer"></div>

<!-- Course and Subjects ends here -->



<!-- RAR -->

<div class="rar">

  <h1>Result Analysis Report</h1>

  <h3>Designed to provide Detailed Insights into your Child's Test Performance.</h3>

  <img src="assets/images/ep-rar.png" alt="">

</div>


 <!-- section 6 starts here -->

  <div class="section-6">
    <h1>Offline Activities</h1>
    <h3>TAKE A LOOK - WHERE WE HAVE BEEN UP TO RECENTLY</h3>

    <div class="gallery-container">
      <div class="gal-left">
        <img
          [src]="currentImage"
          alt="Event Image"
          class="large-image"
          [class.zoom]="isSliding"
        />
      </div>

      <div class="gal-right">
        <h1 class="img-title">{{ currentTitle }}</h1>

        <!-- <div class="btn-div">
         <button class="gal-btn" [routerLink]="['/sehyog/photo-gallery']">View Photos</button>
         <button class="gal-btn sd" [routerLink]="['/sehyog/video-gallery']">View Videos</button>
        </div> -->

        <div class="spacer"></div>
        <div class="spacer"></div>
        <div class="spacer"></div>

        <div class="gal-thumb">
          <img
            *ngFor="let img of gal_images; let i = index"
            [src]="img.src"
            (click)="changeImage(i)"
            [class.active]="i === currentIndex"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- section 6 ends here -->

<!-- Microsoft Clarity -->
<script type="text/javascript">
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/XXXX";
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "XXXX");
</script>
